// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pIbu","left":"styles_left__2jFa1"};